import React, { Component } from 'react';
import '../App.css'
import "../styles/globals.css";
//import { useState, useEffect } from "react";
//import { useStatus } from "../context/statusContext";
//import { connectWallet, getCurrentWalletConnected } from "../utils/interact";
//import { connectWallet } from "../utils/interact";

/*
const connectWalletPressed = async () => {
    console.log('butona basıldı')
    const walletResponse = await connectWallet();
    console.log('dönen adres: ', walletResponse.address)
    console.log('dönen status: ', walletResponse.status)
    this.setState({ walletAddress: walletResponse.address });
    this.setState({ bilgi: walletResponse.status });

};
*/
class Navbar extends Component {



    constructor(props) {
        super(props);
        this.state = {
            walletAddress: '',
            bilgi: 'Cüzdan Bağlı Değil',
        };
    }

    async componentDidMount() {
        // Asking if metamask is already present or not
        if (window.ethereum) {
            this.setState({ bilgi: "" });
        } else {
            this.setState({ bilgi: "install metamask extension!!" });
        }

        // this.loadBlockchainData()
        //console.log("url : ", this.state.mynftList);
    }

    render() {


        return (

            <nav className="navbar navbar-expand-lg navbar-dark fixed-top bg-dark flex-md-nowrap p-0 ">
                <div className="container-fluid">
                    <img src='metamall.gif' alt="" width="50" height="50" className="d-inline-block align-text-top" />
                    <a className="navbar-brand" href="/#">
                        MetaMall
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
                        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="/#">About</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/#about">Sample NFT's</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/#scene">Metamall Scene</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/#mynfts">Your NFTs/Stores</a>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="/#" id="navbarDropdownMenuLink" role="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    Mint link
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                    <li><a className="dropdown-item" href="/#presale">Presale</a></li>
                                    <li><a className="dropdown-item" href="/#sale">Sale</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                    <li className="nav-item text-nowrap text-right d-sm-block">

                        <small className="text-white">

                            {this.props.account > 0 ? (
                                "Connected: " +
                                String(this.props.account).substring(0, 6) +
                                "..." +
                                String(this.props.account).substring(38) + "___"
                            ) : (
                                <span>Connect Wallet</span>
                            )}
                        </small>

                    </li>
                </ul>
                {
                    this.state.bilgi && (
                        <div className="flex items-center justify-center px-4 py-4 mt-8 font-semibold text-white bg-red-400 rounded-md ">
                            {this.state.bilgi}
                        </div>
                    )
                }
            </nav>

        );

    }
}

export default Navbar;